import { useEffect, useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import { connect } from "react-redux";
import { EmptyJobsPage } from "../../assets/images";
import {
  AddDocumentLinkPayloadType,
  AddJobProgressCommentPayload,
  GetAllAssignedClientsOpenJobsPayloadType,
  GetAllDocumentsLinkPayloadType,
  GetJobProgressCommentsPayload,
} from "../../commonTypes/listing";
import { JobProgressTable } from "../../components/AdminReports";
import JobProgressFilter from "../../components/AdminReports/JobProgress/JobProgressFilter";
import {
  EmptyListPage,
  ErrorSuccessModal,
  Loader,
  TableLoader,
} from "../../components/commons";
import { SearchIcon } from "../../components/Icon";
import LinkUploadModal from "../../components/JobListing/LinkUploadModal";
import ProgressCommentsModal from "../../components/JobListing/ProgressCommentsModal";
import JobClosureApproveAndSendModal from "../../components/ThinksToDo/JobClosureModule/JobClosureApproveAndSendModal";
import { JOB_PENDING_APPROVAL_HEADERS } from "../../constant/tableHeadersConstants/jobProgressHeaderConst";
import { resetSession } from "../../redux/auth";
import { LoginResponseType } from "../../redux/auth/authTypes";
import { resetMessage } from "../../redux/clientSettings";
import {
  addJobClosureAction,
  addJobCommentsAction,
  addJobLinkAction,
  getJobCommentsDetailsAction,
  getJobLinksDetailsAction,
  getUserMapedClientJobListAction,
  resetAssignedClientsOpenJobsList,
  resetDocumentsLinkList,
  resetError,
  resetJobProgressCommentsListing,
  resetJobProgressCommentsSuccess,
  resetSuccess,
} from "../../redux/jobs";
import {
  DocumentsLinkType,
  JobProgressCommentType,
} from "../../redux/listing/listingTypes";
import { RootState } from "../../redux/rootReducers";
import JobsSorting from "../Jobs/Jobs/FilterAndShorting/JobsSorting";
import {
  getJobClosureListAction,
  resetJobClosureListData,
  resetThinksToDoError,
  resetThinksToDoMessage,
  resetThinksToDoSuccess,
} from "../../redux/thinksToDo";

type AppProps = {
  fetching: boolean;
  token: string | null;
  statusCode: number | null;
  success: any;
  message: string;
  approveOrRejectMessage: string | null;
  error: any;
  // openJobsListing: any[] | [];
  jobClosureListData: any;
  loginData: LoginResponseType;
  documentsLinkList: [] | DocumentsLinkType[];
  jobProgressCommentsFetching: boolean;
  jobProgressCommentsList: [] | JobProgressCommentType[];
  jobProgressCommentsSuccess: number | null;
  totalAllOpenShareJobsCount: number;
  // jobClosureListForRM: any[] | [];
  dispatchResetSession: () => void;
  dispatchResetJobClosureListData: () => void;
  dispatchResetListingError: () => void;
  dispatchResetListingSuccess: () => void;
  dispatchResetThinksToDoMessage: () => void;
  dispatchResetAssignedClientsOpenJobsListAction: () => void;
  dispatchGetAllAssignedClientsOpenJobsAction: (
    data: GetAllAssignedClientsOpenJobsPayloadType
  ) => void;
  dispatchResetJobProgressCommentsListing: () => void;
  dispatchResetJobProgressCommentsSuccess: () => void;
  dispatchGetAllJobProgressCommentsAction: (
    data: GetJobProgressCommentsPayload
  ) => void;
  dispatchAddDocumentLinkAction: (data: AddDocumentLinkPayloadType) => void;
  dispatchAddJobProgressCommentAction: (
    data: AddJobProgressCommentPayload
  ) => void;
  dispatchGetDocumentsLinkAction: (
    data: GetAllDocumentsLinkPayloadType
  ) => void;
  dispatchResetDocumentsLinkList: () => void;
  dispatchAddJobClosureAction: (data: any) => void;
  dispatchResetMessage: () => void;
  dispatchGetJobClosureListAction: (data: any) => void;
};

const JobsPendingApprovalListing = ({
  fetching,
  token,
  success,
  approveOrRejectMessage,
  error,
  message,
  statusCode,
  // openJobsListing,
  loginData,
  jobClosureListData,
  jobProgressCommentsFetching,
  jobProgressCommentsList,
  totalAllOpenShareJobsCount,
  dispatchResetJobClosureListData,
  dispatchResetAssignedClientsOpenJobsListAction,
  dispatchResetListingSuccess,
  dispatchResetListingError,
  dispatchGetAllAssignedClientsOpenJobsAction,
  dispatchGetAllJobProgressCommentsAction,
  dispatchAddDocumentLinkAction,
  dispatchGetDocumentsLinkAction,
  dispatchAddJobProgressCommentAction,
  dispatchResetSession,
  documentsLinkList,
  jobProgressCommentsSuccess,
  dispatchResetJobProgressCommentsSuccess,
  dispatchResetDocumentsLinkList,
  dispatchAddJobClosureAction,
  dispatchResetMessage,
  dispatchGetJobClosureListAction,
  dispatchResetThinksToDoMessage,
}: AppProps) => {
  const [showProgressCommentsModal, setShowProgressCommentsModal] =
    useState<boolean>(false);
  const [jobProgressComment, setJobProgressComments] = useState<
    JobProgressCommentType[] | []
  >([]);
  const [jobsData, setJobsData] = useState<any | null>(null);
  const [showLinkUploadModal, setShowLinkUploadModal] =
    useState<boolean>(false);
  const [showUsersWorkingOnJob, setShowUserWorkingOnJob] =
    useState<boolean>(false);
  const [jobId, setJobId] = useState<any>("");
  const [modalType, setModalType] = useState<string>("");
  const [searchData, setSearchData] = useState("");
  const getPage = "assigned-Client-Open-JobList";
  const [jobTypeId, setJobTypeId] = useState("");
  const [showUsersWorkingOnJobData, setShowUsersWorkingOnJobData] =
    useState(null);
  const [toggleSort, setToggleSort] = useState<boolean>(false);
  const [sortByTargetEndDate, setSortByTargetEndDate] = useState({
    name: "",
    value: "",
  });
  const [sortByJobType, setSortByTargetJobType] = useState({
    name: "",
    value: "",
  });
  const [sortByStatus, setSortByStatus] = useState({ name: "", value: "" });
  const [sortByClientCode, setSortByClientCode] = useState({
    name: "",
    value: "",
  });
  const [sortByClientName, setSortByClientName] = useState({
    name: "",
    value: "",
  });
  const [recently, setRecently] = useState({ name: "", value: "" });
  const [commentState, setCommentState] = useState<boolean>(false);
  const [clearFilter, setClearFilter] = useState<boolean>(false);
  const [jobPriority, setJobPriority] = useState({
    value: null,
    label: "Select..",
  });
  const [openStatus, setOpenStatus] = useState("");
  const [openStatusValue, setOpenStatusValue] = useState<string>("");
  const [offset, setOffset] = useState(0);
  const [openJobDetailDataModal, setOpenJobDetailDataModal] =
    useState<boolean>(false);
  const [
    showApproveAndSendForClosureModal,
    setShowApproveAndSendForClosureModal,
  ] = useState<boolean>(false);
  const [mongoJobId, setMongoJobId] = useState<string>("");
  const [
    showApproveAndRejectForClosureModal,
    setShowApproveAndRejectForClosureModal,
  ] = useState<boolean>(false);
  const [approveAndRejectJobTypeId, setApproveAndRejectJobTypeId] =
    useState("");
  const [approveAndRejectJobId, setApproveAndRejectJobId] = useState("");
  useEffect(() => {
    dispatchResetJobClosureListData();
    if (token) {
      const finalData = {
        token,
        offset: 0,
        limit: 100000,
        role: "manager",
        internalStatus: "1",
        type: "things_to_do_manager",
      };
      dispatchGetJobClosureListAction(finalData);
    }
  }, []);

  useEffect(() => {
    dispatchResetListingError();
    dispatchResetThinksToDoMessage();
    dispatchResetListingSuccess();
    dispatchResetAssignedClientsOpenJobsListAction();
    dispatchResetJobProgressCommentsSuccess();
    window.scroll({
      top: 0,
      left: 0,
    });

    if (token) {
      let finalData: GetAllAssignedClientsOpenJobsPayloadType = {
        token,
        status: "Open",
        search_term: searchData?.length >= 3 ? searchData : "",
        endDate: sortByTargetEndDate?.value,
        jobType: sortByJobType?.value,
        sortByClientCode: sortByClientCode?.value,
        clientName: sortByClientName?.value,
        jobPriority: jobPriority?.value,
        internalStatus: "1",
      };
      if (clearFilter) {
        setClearFilter(false);
        setJobPriority({
          value: null,
          label: "Select..",
        });
      }
      // dispatchGetAllAssignedClientsOpenJobsAction(finalData);
    }
  }, [clearFilter]);

  useEffect(() => {
    if (jobProgressCommentsList) {
      setJobProgressComments(jobProgressCommentsList);
    }
  }, [jobProgressCommentsList]);

  useEffect(() => {
    dispatchResetListingError();
    dispatchResetListingSuccess();
    dispatchResetAssignedClientsOpenJobsListAction();
    if (
      token &&
      (sortByTargetEndDate?.name ||
        sortByJobType?.name ||
        sortByStatus?.name ||
        sortByClientCode?.name ||
        sortByClientName?.name ||
        recently?.name)
    ) {
      let finalData: GetAllAssignedClientsOpenJobsPayloadType = {
        token,
        status: "Open",
        search_term: searchData?.length >= 3 ? searchData : "",
        endDate: sortByTargetEndDate?.value,
        jobType: sortByJobType?.value,
        sortByClientCode: sortByClientCode?.value,
        clientName: sortByClientName?.value,
        jobPriority: jobPriority?.value,
        internalStatus: "1",
      };
      // dispatchGetAllAssignedClientsOpenJobsAction(finalData);
    }
  }, [
    sortByTargetEndDate,
    sortByJobType,
    sortByStatus,
    recently,
    sortByClientCode,
    sortByClientName,
  ]);

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (searchData && searchData.length >= 3) {
        fetchNewData(searchData);
      }
    }, 500);

    return () => clearTimeout(delayDebounceFn);
  }, [searchData]);

  const handleSubmit = () => {
    dispatchResetAssignedClientsOpenJobsListAction();
    setClearFilter(false);

    if (token) {
      let finalData = {
        token,
        status: "Open",
        search_term: searchData?.length >= 3 ? searchData : "",
        endDate: sortByTargetEndDate?.value,
        jobType: sortByJobType?.value,
        sortByClientCode: sortByClientCode?.value,
        clientName: sortByClientName?.value,
        jobPriority: jobPriority?.value,
        internalStatus: "1",
      };
      // dispatchGetAllAssignedClientsOpenJobsAction(finalData);
    }
  };

  const handleToggleProgressCommentsModal = () => {
    setShowProgressCommentsModal(!showProgressCommentsModal);
    if (commentState) {
      if (token) {
        let finalData: GetAllAssignedClientsOpenJobsPayloadType = {
          token,
          status: "Open",
          search_term: searchData?.length >= 3 ? searchData : "",
          endDate: sortByTargetEndDate?.value,
          jobType: sortByJobType?.value,
          sortByClientCode: sortByClientCode?.value,
          clientName: sortByClientName?.value,
          jobPriority: jobPriority?.value,
          internalStatus: "1",
        };
        // dispatchGetAllAssignedClientsOpenJobsAction(finalData);
      }
    }
  };

  const handleToggleLinkUploadModal = () => {
    setShowLinkUploadModal(!showLinkUploadModal);
  };
  const handleToggleUserWorkingOnJob = () => {
    setShowUserWorkingOnJob(!showUsersWorkingOnJob);
  };
  const handleSetJobsData = (data: any, type: string) => {
    setJobProgressComments([]);
    setJobsData(data);
    setJobId(data?._id);
    setModalType(type);

    if (type === "comments") {
      let finalData: GetJobProgressCommentsPayload = {
        job_id: data?._id,
        token,
      };

      dispatchGetAllJobProgressCommentsAction(finalData);
    } else if (type === "documents") {
      dispatchResetDocumentsLinkList();
      let finalData: GetAllDocumentsLinkPayloadType = {
        job_id: data?._id,
        token,
      };

      dispatchGetDocumentsLinkAction(finalData);
    }
  };

  const toggleApproveAndSendJob = (data: any) => {
    setShowApproveAndRejectForClosureModal(
      !showApproveAndRejectForClosureModal
    );
    setApproveAndRejectJobTypeId(data?._id);
    setApproveAndRejectJobId(data?.job_id);
    setJobTypeId(data?.job_id);
    setJobId(data?._id)
    
  };

  const handleSubmitJobComment = (data: any) => {
    setCommentState(true);
    let finalData: AddJobProgressCommentPayload = {
      job_id: data?.id,
      comment: data?.commentText,
      token,
    };
    dispatchAddJobProgressCommentAction(finalData);
  };

  const handleSubmitDocumentLink = (data: AddDocumentLinkPayloadType) => {
    let finalData: AddDocumentLinkPayloadType = {
      link: data?.link,
      token,
      job_id: data?.job_id,
      description: data?.description,
    };

    dispatchAddDocumentLinkAction(finalData);
  };

  const handleSearch = (e: any) => {
    let value = e.target.value;
    setSearchData(value);

    if (!value) {
      let finalData: GetAllAssignedClientsOpenJobsPayloadType = {
        token,
        status: "Open",
        search_term: value?.length >= 3 ? value : "",
        endDate: sortByTargetEndDate?.value,
        jobType: sortByJobType?.value,
        sortByClientCode: sortByClientCode?.value,
        clientName: sortByClientName?.value,
        jobPriority: jobPriority?.value,
        internalStatus: "1",
      };
      // dispatchGetAllAssignedClientsOpenJobsAction(finalData);
    }
  };
  const getJobId = (data: any) => {
    setShowUsersWorkingOnJobData(data);
    setMongoJobId(data?._id);
    setOpenJobDetailDataModal(!openJobDetailDataModal);
    setJobTypeId(data?.job_id);
    setJobId(data?._id)
  };
  const handleToggleRMClosureJob = () => {
    setOpenJobDetailDataModal(!openJobDetailDataModal);
  };
  const handleSorting = (data: any) => {
    if (
      data?.name === "Target End Date - Ascending" ||
      data?.name === "Target End Date - Descending"
    ) {
      setSortByTargetEndDate(data);
      setSortByTargetJobType({ name: "", value: "" });
      setSortByClientName({ name: "", value: "" });
      setSortByClientCode({ name: "", value: "" });
      setSortByStatus({ name: "", value: "" });
      setRecently({ name: "", value: "" });
    } else if (
      data?.name === "Client - A to Z" ||
      data?.name === "Client - Z to A"
    ) {
      setSortByClientName(data);
      setSortByTargetEndDate({ name: "", value: "" });
      setSortByTargetJobType({ name: "", value: "" });
      setSortByStatus({ name: "", value: "" });
      setSortByClientCode({ name: "", value: "" });
      setRecently({ name: "", value: "" });
    } else if (
      data?.name === "Client Code - Ascending" ||
      data?.name === "Client Code - Descending"
    ) {
      setSortByClientCode(data);
      setSortByTargetEndDate({ name: "", value: "" });
      setSortByTargetJobType({ name: "", value: "" });
      setSortByStatus({ name: "", value: "" });
      setSortByClientName({ name: "", value: "" });
      setRecently({ name: "", value: "" });
    } else if (
      data?.name === "Job Type - A to Z" ||
      data?.name === "Job Type - Z to A"
    ) {
      setSortByTargetJobType(data);
      setSortByTargetEndDate({ name: "", value: "" });
      setSortByClientName({ name: "", value: "" });
      setSortByClientCode({ name: "", value: "" });
      setSortByStatus({ name: "", value: "" });
      setRecently({ name: "", value: "" });
    } else if (data?.name === "Jobs with Open Status First") {
      setSortByStatus(data);
      setSortByTargetEndDate({ name: "", value: "" });
      setSortByClientName({ name: "", value: "" });
      setSortByClientCode({ name: "", value: "" });
      setSortByTargetJobType({ name: "", value: "" });
      setRecently({ name: "", value: "" });
    } else {
      setRecently(data);
      setSortByStatus({ name: "", value: "" });
      setSortByTargetEndDate({ name: "", value: "" });
      setSortByClientName({ name: "", value: "" });
      setSortByClientCode({ name: "", value: "" });
      setSortByTargetJobType({ name: "", value: "" });
    }
  };

  const fetchNewData = (search?: string) => {
    if (token) {
      let finalData = {
        token,
        search_term: search
          ? search
          : searchData && searchData.length >= 3
          ? searchData
          : "",
        status: "Open",
        endDate: sortByTargetEndDate?.value,
        jobType: sortByJobType?.value,
        sortByClientCode: sortByClientCode?.value,
        clientName: sortByClientName?.value,
        jobPriority: jobPriority?.value,
        internalStatus: "1",
      };
      // dispatchGetAllAssignedClientsOpenJobsAction(finalData);
    }
    dispatchResetListingError();
    dispatchResetListingSuccess();
  };

  const handleSentJobForClosuring = (data: any) => {
    if (token) {
      let finalData = {
        token,
        job_id: data?.job_id,
        client_code: data?.client_details?.client_code,
      };
      dispatchAddJobClosureAction(finalData);
    }
  };
  const handleToggleManagerApproveAndSendJob = () => {
    setShowApproveAndSendForClosureModal(!showApproveAndSendForClosureModal);
  };

  const handleToggleManagerApproveAndRejectJob = () => {
    setShowApproveAndRejectForClosureModal(
      !showApproveAndRejectForClosureModal
    );
  };

  const handleErrorSuccessModal = () => {
    if (jobProgressCommentsSuccess === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        );
      } else if (!!error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetListingError();
            }}
          />
        );
      }
    }

    if (jobProgressCommentsSuccess === 1) {
      dispatchResetJobProgressCommentsSuccess();
      if (modalType === "comments") {
        toast.success("Comment Added Successfully!", {
          duration: 2000,
        });

        let finalData: GetJobProgressCommentsPayload = {
          job_id: jobId,
          token,
        };

        dispatchGetAllJobProgressCommentsAction(finalData);
      } else if (modalType === "documents") {
        toast.success("Document Link Added Successfully!", {
          duration: 2000,
        });

        let finalData: GetAllDocumentsLinkPayloadType = {
          job_id: jobId,
          token,
        };

        dispatchGetDocumentsLinkAction(finalData);
        dispatchResetJobProgressCommentsSuccess();
      }
    }
    if (
      jobProgressCommentsSuccess === 1 &&
      message?.includes("Job closure details have been sent successfully")
    ) {
      dispatchResetListingError();
      dispatchResetListingSuccess();
      dispatchResetAssignedClientsOpenJobsListAction();
      toast.success("Job closure details have been sent successfully!", {
        duration: 2000,
      });

      if (token) {
        let finalData = {
          token,
          status: "Open",
          search_term: searchData?.length >= 3 ? searchData : "",
          endDate: sortByTargetEndDate?.value,
          jobType: sortByJobType?.value,
          sortByClientCode: sortByClientCode?.value,
          clientName: sortByClientName?.value,
          jobPriority: jobPriority?.value,
          internalStatus: "1",
        };
        if (offset === 0) {
          // dispatchGetAllAssignedClientsOpenJobsAction(finalData);
        }
      }
    }
    if (
      approveOrRejectMessage === "Job closure request has been approved." ||
      approveOrRejectMessage === "Job closure request has been rejected."
    ) {
      toast.success(
        approveOrRejectMessage === "Job closure request has been approved."
          ? "Job closure request has been approved"
          : "Job closure request has been rejected",
        {
          duration: 2000,
        }
      );

      // dispatchResetThinksToDoError();
      dispatchResetThinksToDoMessage();
      // dispatchResetThinksToDoStatusCode();
      // dispatchResetThinksToDoSuccess();
      if (token) {
        const finalData = {
          token,
          offset: 0,
          limit: 100000,
          role: "manager",
          internalStatus: "1",
          type: "things_to_do_manager",
        };
        dispatchGetJobClosureListAction(finalData);
      }
    }

    return false;
  };
  return (
    <>
      <div
        className="col-md-12 text-right d-flex flex-row"
        style={{
          justifyContent: "flex-end",
          padding: "10px",
          backgroundColor: "#fff",
        }}
      >
        <div className="col-md-5 flex-start" style={{ padding: 0 }}>
          <div
            className="d-flex flex-column"
            style={{ justifyContent: "center", alignItems: "flex-start" }}
          >
            <div className="flex-center" style={{ gap: "5px" }}>
              <div style={{ fontSize: "18px", fontWeight: 500 }}>
                Jobs Pending Approval List
              </div>
            </div>
            {!fetching && (
              <div
                style={{
                  color: "rgb(124, 141, 176)",
                  fontSize: "13px",
                  fontWeight: 500,
                }}
              >
                Total{" "}
                {/* {totalAllOpenShareJobsCount ? totalAllOpenShareJobsCount : 0}{" "} */}
                {jobClosureListData?.length} entries found
              </div>
            )}
          </div>
        </div>
        <div
          className="col-md-7 d-flex justify-content-end"
          style={{ gap: "3%" }}
        >
          {/* <div
            className="col-md-6 position-relative"
            style={{ marginRight: "-29px", marginLeft: "-10px" }}
          >
            <span style={{ position: "absolute", top: "8px", left: "25px" }}>
              <SearchIcon />
            </span>
            <input
              className="form-control"
              type="text"
              placeholder="Search Document (Min. 3 characters)"
              onChange={(e) => handleSearch(e)}
              style={{ paddingLeft: "35px" }}
            />
          </div> */}
          {/* <div className="form-group">
            <JobProgressFilter
              setOffset={setOffset}
              openStatus={openStatus}
              setOpenStatus={setOpenStatus}
              openStatusValue={openStatusValue}
              setOpenStatusValue={setOpenStatusValue}
              setClearFilter={setClearFilter}
              jobPriority={jobPriority}
              setJobPriority={setJobPriority}
              handleSubmit={handleSubmit}
              type={"openJob"}
            />
          </div> */}
          {/* <div style={{ marginLeft: "-12px" }}>
            <JobsSorting
              type={"Open"}
              handleSorting={handleSorting}
              setToggle={setToggleSort}
              toggle={toggleSort}
              selectedData={
                sortByTargetEndDate?.value
                  ? sortByTargetEndDate
                  : sortByJobType?.value
                  ? sortByJobType
                  : sortByStatus?.value
                  ? sortByStatus
                  : sortByClientCode?.value
                  ? sortByClientCode
                  : sortByClientName?.value
                  ? sortByClientName
                  : { name: "Recently Added/Modified First", value: "" }
              }
            />
          </div> */}
        </div>
      </div>
      {fetching && jobClosureListData?.length == 0 ? (
        <TableLoader Rows={10} ColumnPerRow={7} />
      ) : jobClosureListData?.length ? (
        <>
          <JobProgressTable
            data={jobClosureListData}
            headers={JOB_PENDING_APPROVAL_HEADERS}
            type={"underline"}
            fetching={fetching}
            getJobId={getJobId}
            handleSetJobsData={handleSetJobsData}
            handleToggleProgressCommentsModal={
              handleToggleProgressCommentsModal
            }
            isAdminReport={true}
            handleToggleLinkUploadModal={handleToggleLinkUploadModal}
            shareJobList={false}
            jobApprovalPending={true}
            handleSentJobForClosuring={handleSentJobForClosuring}
            loginData={loginData}
            tab="jobsPendingApproval"
            handleApproveAndSendModal={toggleApproveAndSendJob}
          />
        </>
      ) : (
        <div className="mt-5 p-4">
          <EmptyListPage
            title="No Data Found!"
            image={EmptyJobsPage}
            imageWidth="30%"
            showLinkButton={false}
            showAddButton={false}
          />
        </div>
      )}
      {fetching && <Loader />}

      {handleErrorSuccessModal()}
      {showProgressCommentsModal && (
        <ProgressCommentsModal
          modal={showProgressCommentsModal}
          toggleModal={handleToggleProgressCommentsModal}
          data={jobsData}
          characterLength={150}
          commentFetching={jobProgressCommentsFetching}
          jobProgressCommentsList={jobProgressComment}
          handlePostComment={handleSubmitJobComment}
          showClientName
          showInputBox
          // showDetails
          isAdmin
        />
      )}
      {showLinkUploadModal && (
        <LinkUploadModal
          modal={showLinkUploadModal}
          toggleModal={handleToggleLinkUploadModal}
          data={jobsData}
          showInputBox
          client_code={jobsData?.client_details?.client_code}
          company_name={jobsData?.client_details?.company_name}
          handleAddDocumentLink={handleSubmitDocumentLink}
          documentsLinkList={documentsLinkList}
          commentFetching={jobProgressCommentsFetching}
          isAdmin
          title={getPage}
          jobPriority={jobPriority}
        />
      )}

      {/* {
  showUsersWorkingOnJob && (
    <ShowUsersWorkingOnJobModal
      modal={showUsersWorkingOnJob}
      toggleModal={handleToggleUserWorkingOnJob}
      jobTypeId={jobTypeId}
      showUsersWorkingOnJobData={showUsersWorkingOnJobData}
    />

  )
} */}
      {openJobDetailDataModal && (
        <JobClosureApproveAndSendModal
          modal={openJobDetailDataModal}
          toggleModal={handleToggleRMClosureJob}
          jobTypeId={jobTypeId}
          jobId={jobId}
          type={"Employee"}
        />
      )}
      {showApproveAndSendForClosureModal && (
        <JobClosureApproveAndSendModal
          modal={showApproveAndSendForClosureModal}
          toggleModal={handleToggleManagerApproveAndSendJob}
          jobTypeId={jobTypeId}
          jobId={jobId}
          type={"manager"}
        />
      )}
      {showApproveAndRejectForClosureModal && (
        <JobClosureApproveAndSendModal
          modal={showApproveAndRejectForClosureModal}
          toggleModal={handleToggleManagerApproveAndRejectJob}
          jobTypeId={jobTypeId}
          jobId={jobId}
          type={"manager"}
          hideUserWorkingTab={true}
        />
      )}

      <Toaster />
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  fetching: state.thinksToDo.fetching,
  token: state.auth.token,
  success: state.thinksToDo.success,
  message: state.jobs.message,
  // openJobsListing: state.jobs.assignedClientsOpenJobsList,
  // openJobsListing: [],
  error: state.thinksToDo.error,
  statusCode: state.thinksToDo.statusCode,
  jobProgressCommentsFetching: state.jobs.jobProgressCommentsFetching,
  jobProgressCommentsList: state.jobs.jobProgressCommentsList,
  jobProgressCommentsSuccess: state.jobs.jobProgressCommentsSuccess,
  documentsLinkList: state.jobs.documentsLinkList,
  totalAllOpenShareJobsCount: state.jobs.totalAllOpenJobsCount,
  loginData: state.auth.loginData,
  approveOrRejectMessage: state.thinksToDo.message,
  jobClosureListData: state.thinksToDo.jobClosureListData,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetListingError: () => dispatch(resetThinksToDoError()),
  dispatchResetListingSuccess: () => dispatch(resetThinksToDoSuccess()),
  dispatchResetMessage: () => dispatch(resetMessage()),
  dispatchResetAssignedClientsOpenJobsListAction: () =>
    dispatch(resetAssignedClientsOpenJobsList()),
  dispatchGetAllAssignedClientsOpenJobsAction: (
    data: GetAllAssignedClientsOpenJobsPayloadType
  ) => dispatch(getUserMapedClientJobListAction(data)),
  dispatchResetJobProgressCommentsListing: () =>
    dispatch(resetJobProgressCommentsListing()),
  dispatchResetJobProgressCommentsSuccess: () =>
    dispatch(resetJobProgressCommentsSuccess()),
  dispatchGetAllJobProgressCommentsAction: (
    data: GetJobProgressCommentsPayload
  ) => dispatch(getJobCommentsDetailsAction(data)),
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchGetDocumentsLinkAction: (data: GetAllDocumentsLinkPayloadType) =>
    dispatch(getJobLinksDetailsAction(data)),
  dispatchAddDocumentLinkAction: (data: AddDocumentLinkPayloadType) =>
    dispatch(addJobLinkAction(data)),
  dispatchResetDocumentsLinkList: () => dispatch(resetDocumentsLinkList()),
  dispatchAddJobProgressCommentAction: (data: AddJobProgressCommentPayload) =>
    dispatch(addJobCommentsAction(data)),
  //
  dispatchAddJobClosureAction: (data: any) =>
    dispatch(addJobClosureAction(data)),
  dispatchResetThinksToDoMessage: () => dispatch(resetThinksToDoMessage()),
  dispatchGetJobClosureListAction: (data: any) =>
    dispatch(getJobClosureListAction(data)),
  dispatchResetJobClosureListData: () => dispatch(resetJobClosureListData()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(JobsPendingApprovalListing);
